import { Tab, withStyles } from '@material-ui/core';

const PrimaryTab = withStyles({
    selected: {
        color: '#FEDD31',
    },
})(Tab);

export default PrimaryTab;
